export default function (component) {
  let module = null;
  switch (component) {
    case "Layout":
      return require("@/Layout").default;
    // case 'Test':
    //   return require('@/views/table/index').default
    case "Parent":
      return require("@/components/Parent/index").default;
    default:
      try {
        module = require("@/views/" + component + "/index").default;
      } catch (error) {
        module = require("@/views/404.vue").default;
      }
      return module;
  }
}
